import appStore from "@/stores/appStore";
import { CamelCasedProperties, SnakeCasedProperties } from "./tsUtils/typeTranslate";

function snakeToCamelCase(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export const convertKeysToCamelCase = <T extends Object>(obj: T): CamelCasedProperties<T> => {
  return Object.keys(obj).reduce((acc, key) => {
    const camelCaseKey = snakeToCamelCase(key);
    const value = obj[key as keyof T];

    (acc as any)[camelCaseKey as keyof CamelCasedProperties<T>] =
      typeof value === "object" && value !== null && !Array.isArray(value) ? convertKeysToCamelCase(value) : value;

    return acc;
  }, {} as CamelCasedProperties<T>);
};

function camelToSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export const convertKeysToSnakeCase = <T extends Object>(obj: T): SnakeCasedProperties<T> => {
  return Object.keys(obj).reduce((acc, key) => {
    const snakeCaseKey = camelToSnakeCase(key);
    const value = obj[key as keyof T];

    (acc as any)[snakeCaseKey] =
      typeof value === "object" && value !== null && !Array.isArray(value) ? convertKeysToSnakeCase(value) : value;

    return acc;
  }, {} as SnakeCasedProperties<T>);
};

export const copyText = (text) => {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
};

/**
 * XOR加密
 * @param {string} text - 要加密的文本
 * @param {string} key - 加密密钥
 * @returns {string} Base64编码的加密结果
 */
export function xorEncode(text: string, key: string) {
  if (!text || !key) return "";

  let result = "";
  for (let i = 0; i < text.length; i++) {
    const textChar = text.charCodeAt(i);
    const keyChar = key.charCodeAt(i % key.length);
    result += String.fromCharCode(textChar ^ keyChar);
  }

  // 使用btoa进行Base64编码，使结果可显示
  return btoa(result);
}

/**
 * XOR解密
 * @param {string} encodedText - Base64编码的加密文本
 * @param {string} key - 解密密钥（必须与加密密钥相同）
 * @returns {string} 解密后的文本
 */
export function xorDecode(encodedText: string, key: string) {
  if (!encodedText || !key) return "";

  try {
    // 先进行Base64解码
    const decoded = atob(encodedText);
    let result = "";

    for (let i = 0; i < decoded.length; i++) {
      const encodedChar = decoded.charCodeAt(i);
      const keyChar = key.charCodeAt(i % key.length);
      result += String.fromCharCode(encodedChar ^ keyChar);
    }

    return result;
  } catch (error) {
    console.error("解密失败:", error);
    return "";
  }
}
